import { SwitchCase } from '@toss/react';
import { type HintType } from '../type';
import { ImageHintInput } from './ImageHintInput';
import { TextHintInput } from './TextHintInput';
import { YoutubeHintInput } from './YoutubeHintInput';
export const HintInput = ({
  type,
  value,
  onChange
}: {
  type: HintType;
  value: string;
  onChange: (value: string) => void;
}) => {
  return <SwitchCase value={type} caseBy={{
    text: <TextHintInput value={value} onChange={onChange} />,
    image: <ImageHintInput value={value} onChange={onChange} />,
    youtube: <YoutubeHintInput value={value} onChange={onChange} />
  }} data-sentry-element="SwitchCase" data-sentry-component="HintInput" data-sentry-source-file="HintInput.tsx"></SwitchCase>;
};